module.exports = __webpack_public_path__ + "img/苦参实.738939c8.jpg";